import { cn } from 'lib/helpers/utility';

export const CARD_FIELDS = {
  'card-holder-name': { label: 'Cardholder name' },
  'card-number': { label: 'Card number' },
  'card-expiry': { label: 'Expiration' },
  'card-cvv': { label: 'CVC' }
};

const SIDE_BY_SIDE_ROW = 'flex w-full gap-3 sm:flex-col';

export const getDefaultCardFieldRows = (flexRow) => [
  {
    fields: ['card-holder-name', 'card-number'],
    className: cn('flex w-full flex-col gap-1', flexRow && 'flex-row gap-3 sm:flex-col')
  },
  { fields: ['card-expiry', 'card-cvv'], className: SIDE_BY_SIDE_ROW }
];

const FULL_WIDTH_ROW = 'flex w-full flex-col gap-1';

export const CARD_FIELD_ROWS_NUMBER_FIRST = [
  { fields: ['card-number'], className: FULL_WIDTH_ROW },
  { fields: ['card-expiry', 'card-cvv'], className: SIDE_BY_SIDE_ROW },
  { fields: ['card-holder-name'], className: FULL_WIDTH_ROW }
];

export const PAIRED_CARD_FIELD_ROWS = [
  { fields: ['card-number', 'card-expiry'], className: SIDE_BY_SIDE_ROW },
  { fields: ['card-cvv', 'card-holder-name'], className: SIDE_BY_SIDE_ROW }
];
